import * as React from 'react';
import * as autoBind from 'react-autobind';
import {RouteComponentProps} from 'react-router';
import TabModel from '../../types/TabModel';
import Tabs from '../Tabs/Tabs';
import {DashboardFilter} from '../../globals/Constants';
import Strings from '../../globals/Strings';

export default class FilterTabs extends React.Component<FilterTabsProps, FilterTabsState> {
   readonly state: FilterTabsState = {
      allTab: {text: Strings.tabs.dashboard.all, onClick: this.onFilterAll.bind(this), selected: !new URLSearchParams(this.props.location.search).get('filter') && !this.props.dashboardFilter},
      ownedTab: {text: Strings.tabs.dashboard.owned, onClick: this.onFilterOwned.bind(this), selected: new URLSearchParams(this.props.location.search).get('filter') === DashboardFilter.owned || this.props.dashboardFilter === DashboardFilter.owned},
      othersTab: {text: Strings.tabs.dashboard.others, onClick: this.onFilterOthers.bind(this), selected: new URLSearchParams(this.props.location.search).get('filter') === DashboardFilter.others || this.props.dashboardFilter === DashboardFilter.others}
   };

   constructor(props: FilterTabsProps) {
      super(props);
      autoBind(this);
   }

   componentDidMount(): void {
      this.setupTabHrefs();
   }

   componentDidUpdate(_: FilterTabsProps, prevState: FilterTabsState): void {
      this.setupTabHrefs(prevState);
   }

   setupTabHrefs(prevState?: FilterTabsState) {
      const {allTab, ownedTab, othersTab} = this.state;
      allTab.href = this.getHrefForFilter(DashboardFilter.all);
      ownedTab.href = this.getHrefForFilter(DashboardFilter.owned);
      othersTab.href = this.getHrefForFilter(DashboardFilter.others);
      if (!prevState) {
         this.setState({allTab: allTab, ownedTab: ownedTab, othersTab: othersTab});
      } else if (
         prevState.allTab.href !== allTab.href ||
         prevState.ownedTab.href !== ownedTab.href ||
         prevState.othersTab.href !== othersTab.href
      ) {
         this.setState({allTab: allTab, ownedTab: ownedTab, othersTab: othersTab});
      }
   }

   getHrefForFilter(value: string) {
      const updatedParams = new URLSearchParams(this.props.location.search);
      if (value) {
         updatedParams.set('filter', value);
      } else {
         updatedParams.delete('filter');
      }
      return `${this.props.location.pathname}?${updatedParams.toString()}`;
   }

   updateFilterAndPushHistory(value: string) {
      this.props.history.push(this.getHrefForFilter(value));
   }

   onFilterAll() {
      this.props.setDashboardFilter('');
      this.updateFilterAndPushHistory('');
   }

   onFilterOwned() {
      this.props.setDashboardFilter(DashboardFilter.owned);
      this.updateFilterAndPushHistory(DashboardFilter.owned);
   }

   onFilterOthers() {
      this.props.setDashboardFilter(DashboardFilter.others);
      this.updateFilterAndPushHistory(DashboardFilter.others);
   }

   render() {
      return (
         <Tabs tabs={[this.state.allTab, this.state.ownedTab, this.state.othersTab]} isAnchor={true}/>
      );
   }
}

export interface FilterTabsProps extends RouteComponentProps {
   dashboardFilter: string;
   setDashboardFilter: (filter: string) => void;
}

export interface FilterTabsState {
   allTab: TabModel;
   ownedTab: TabModel;
   othersTab: TabModel;
}
